import { IconProps } from '@/modules/defines/interface';

const ArrowBigRight = ({ fill }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M3.85296 7.52827L10.6767 7.52827V4.57373C10.6767 4.41081 10.7267 4.25155 10.8205 4.11609C10.9142 3.98063 11.0474 3.87505 11.2032 3.81271C11.3591 3.75036 11.5305 3.73405 11.696 3.76582C11.8614 3.7976 12.0134 3.87604 12.1327 3.99123L17.7503 9.4175C17.9102 9.572 18 9.78153 18 10C18 10.2185 17.9102 10.428 17.7503 10.5825L12.1327 16.0088C12.0134 16.124 11.8614 16.2024 11.696 16.2342C11.5305 16.266 11.3591 16.2496 11.2032 16.1873C11.0474 16.1249 10.9142 16.0194 10.8205 15.8839C10.7267 15.7485 10.6767 15.5892 10.6767 15.4263V12.4717L3.85296 12.4717C3.62674 12.4717 3.40979 12.3849 3.24983 12.2304C3.08987 12.0759 3 11.8663 3 11.6478L3 8.35218C3 8.13367 3.08987 7.9241 3.24983 7.76959C3.40979 7.61508 3.62674 7.52827 3.85296 7.52827Z"
        fill={fill}
      />
    </svg>
  );
};

export default ArrowBigRight;
